import {
  client,
  SiteGroupsControllerListSummariesData,
  SiteGroupSummaryDto,
} from "@/client";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  FormSelectInputAsyncPaginateQueryItem,
  FormSelectInputAsyncPaginateQueryItemCommonProps,
} from "@/components/custom/form-inputs/select-input/select-input-async-pagination";
import { useFilterIsActive } from "@/components/custom/data-table/data-table-context";
import { withPermission } from "@/components/custom/with-permission";
import { listPermissions } from "@/lib/list-permissions";

type TForm = SiteGroupsControllerListSummariesData;

const SiteGroupIdsFilter = withPermission(
  listPermissions.siteGroups,
  SiteGroupIdsFilterControl,
);
function SiteGroupIdsFilterControl(
  props: FormSelectInputAsyncPaginateQueryItemCommonProps,
) {
  const form = useFormContext<TForm>();
  const { t } = useTranslation();
  const perPage = 10;
  return (
    <FormSelectInputAsyncPaginateQueryItem
      form={form}
      name="siteGroupIds"
      label={t("siteGroups")}
      isMulti={true}
      mapping={(v) => ({ value: v!, label: v as unknown as string })}
      queryKey={client.siteGroups.listSummaries.queryKey}
      queryCreator={client.siteGroups.listSummaries.asQueryOptions<any>}
      createOptions={(data) =>
        data.results.map((row: SiteGroupSummaryDto) => ({
          label: row.name!,
          value: row.id!,
        }))
      }
      hasMore={(data, variable) =>
        data.results.length >= perPage && data.total > variable.page * perPage
      }
      requestVariable={(search, page, limit) => ({
        name: search,
        limit: limit ?? perPage,
        page,
      })}
      isActive={useFilterIsActive("siteGroupIds")}
      {...props}
    />
  );
}

export function SiteGroupsFilters() {
  return (
    <>
      <SiteGroupIdsFilter />
    </>
  );
}
